export const REGANTO_PREMIER_REQUEST = "REGANTO_PREMIER_REQUEST";
export const REGANTO_PREMIER_SUCCESS = "REGANTO_PREMIER_SUCCESS";
export const REGANTO_PREMIER_FAILED = "REGANTO_PREMIER_FAILED";
